<template>
  <div class="default-box">
    <h2>お知らせ</h2>
    <input type="button" class="new_add_btn" @click="new_add" value="新しいお知らせを追加" />
    <div class="info-list-box">
      <div class="list-header-box">
        <p class="list-header header-date">日付</p>
        <p class="list-header header-title">タイトル</p>
        <p class="list-header header-content">本文</p>
      </div>
      <div
        v-for="(list, index) in info_list"
        :key="list.id"
        class="list-box"
        @click="info_edit(index)"
      >
        <p class="list-data list-date">{{ date_make(list.date) }}</p>
        <p class="list-data list-title">{{ list.title }}</p>
        <p class="list-data list-content">{{ list.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Default',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      info_list: []
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    this.load_data();
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    load_data () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.load_data_cb;
      ld._load_start('/manage/information_list_get.php');
    },
    load_data_cb (data) {
      if (data.res === 1) {
        this.info_list = data.data.informations;
        this.$store.commit('Info/set_info', this.info_list);
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    date_make (date) {
      return date.substr(0, 4) + '年' +
        date.substr(4, 2) + '月' +
        date.substr(6, 2) + '日';
    },
    new_add () {
      // this.$router.push({name: 'InfoEdit', params: {id: 1}});
      this.$store.commit('Info/set_select_index', -1);
      this.$router.push({name: 'InfoEdit', params: {}});
    },
    info_edit (index) {
      this.$store.commit('Info/set_select_index', index);
      this.$router.push({name: 'InfoEdit', params: {}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.default-box {
  h2 {
    color: #6c5a57;
    text-align: left;
  }

  .list-header-box {
    display: flex;
    padding: 0 10px;
    color: #6c5a57;
    margin: 10px 0;

    .list-header {
      color: #6c5a57;
      font-weight: bold;
      text-align: left;
      padding-left: 10px;
      box-sizing: border-box;
    }

    .header-date {
      min-width: 130px;
      width: 20%;
    }

    .header-title {
      width: 40%;
    }

    .header-title {
      width: 40%;
    }
  }

  .list-box {
    height: 40px;
    border: 1px solid #6c5a57;
    display: flex;
    align-items: center;
    margin: 10px 0;
    padding: 5px 10px;
    box-sizing: border-box;
    border-radius: 5px;
    background-color: #fffced;
    color: #6c5a57;
    cursor: pointer;
    &:hover {
      background-color: #ffefa2;
    }

    .list-data {
      text-align: left;
      padding-left: 10px;
      box-sizing: border-box;
    }

    .list-date {
      min-width: 130px;
      width: 20%;
    }

    .list-title {
      width: 40%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .list-content {
      width: 40%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .new_add_btn {
      color: #fefefe;
      display: block;
      text-align: center;
      padding: 8px;
      width: 300px;
      font-size: 16px;
      margin: 20px 0px 20px 0px;
      text-decoration: none;
      border-radius: 3px;
  }
}
</style>
